export const MORTGAGE_OPERATION_START = 'MORTGAGE_OPERATION_START';
export const MORTGAGE_OPERATION_SUCCESS = 'MORTGAGE_OPERATION_SUCCESS';
export const MORTGAGE_OPERATION_ERROR = 'MORTGAGE_OPERATION_ERROR';

export const INITIATE_MORTGAGE_APPLICATION = 'INITIATE_MORTGAGE_APPLICATION';
export const INITIATE_MORTGAGE_APPLICATION_SUCCESS = 'INITIATE_MORTGAGE_APPLICATION_SUCCESS';
export const INITIATE_MORTGAGE_APPLICATION_ERROR = 'INITIATE_MORTGAGE_APPLICATION_ERROR';

export const FETCH_APPLICATION_MORTGAGE = 'FETCH_APPLICATION_MORTGAGE';
export const FETCH_APPLICATION_MORTGAGE_SUCCESS = 'FETCH_APPLICATION_MORTGAGE_SUCCESS';
export const FETCH_APPLICATION_MORTGAGE_ERROR = 'FETCH_APPLICATION_MORTGAGE_ERROR';

export const SET_CONTRACT_DETAILS = 'SET_CONTRACT_DETAILS';

export const SAVE_APPLICATION_MORTGAGE = 'SAVE_APPLICATION_MORTGAGE';
export const SAVE_APPLICATION_MORTGAGE_SUCCESS = 'SAVE_APPLICATION_MORTGAGE_SUCCESS';
export const SAVE_APPLICATION_MORTGAGE_ERROR = 'SAVE_APPLICATION_MORTGAGE_ERROR';

export const CHANGE_MORTGAGE_STEP = 'CHANGE_MORTGAGE_STEP';

export const DOWNLOAD_DOCUMENT_MORTGAGE = 'DOWNLOAD_DOCUMENT_MORTGAGE';
export const DOWNLOAD_DOCUMENT_MORTGAGE_SUCCESS = 'DOWNLOAD_DOCUMENT_MORTGAGE_SUCCESS';
export const DOWNLOAD_DOCUMENT_MORTGAGE_ERROR = 'DOWNLOAD_DOCUMENT_MORTGAGE_ERROR';

export const SHOW_VALIDATION_MESSAGE = 'SHOW_VALIDATION_MESSAGE';
export const CLEAR_VALIDATION_MESSAGE = 'CLEAR_VALIDATION_MESSAGE';

export const UPLOAD_MORTGAGE_DOCUMENT = 'UPLOAD_MORTGAGE_DOCUMENT';
export const UPLOAD_MORTGAGE_DOCUMENT_SUCCESS = 'UPLOAD_MORTGAGE_DOCUMENT_SUCCESS';
export const UPLOAD_MORTGAGE_DOCUMENT_ERROR = 'UPLOAD_MORTGAGE_DOCUMENT_ERROR';

export const CHECKOUT_MORTGAGE_APPLICATION = 'CHECKOUT_MORTGAGE_APPLICATION';
export const CHECKOUT_MORTGAGE_APPLICATION_SUCCESS = 'CHECKOUT_MORTGAGE_APPLICATION_SUCCESS';
export const CHECKOUT_MORTGAGE_APPLICATION_ERROR = 'CHECKOUT_MORTGAGE_APPLICATION_ERROR';

export const MORTGAGE_CANCEL_APPLICATION = 'MORTGAGE_CANCEL_APPLICATION';
export const MORTGAGE_CANCEL_APPLICATION_SUCCESS = 'MORTGAGE_CANCEL_APPLICATION_SUCCESS';
export const MORTGAGE_CANCEL_APPLICATION_ERROR = 'MORTGAGE_CANCEL_APPLICATION_ERROR';

/** --------------- MORTGAGE BANK MAKER --------------- */
export const SET_MORTGAGE_BANK_MAKER_DETAILS = 'SET_MORTGAGE_BANK_MAKER_DETAILS';

export const FETCH_MORTGAGE_BANK_MAKER_APPLICATION = 'FETCH_MORTGAGE_BANK_MAKER_APPLICATION';
export const FETCH_MORTGAGE_BANK_MAKER_APPLICATION_SUCCESS = 'FETCH_MORTGAGE_BANK_MAKER_APPLICATION_SUCCESS';
export const FETCH_MORTGAGE_BANK_MAKER_APPLICATION_ERROR = 'FETCH_MORTGAGE_BANK_MAKER_APPLICATION_ERROR';

export const SAVE_MORTGAGE_BANK_MAKER_APPLICATION = 'SAVE_MORTGAGE_BANK_MAKER_APPLICATION';
export const SAVE_MORTGAGE_BANK_MAKER_APPLICATION_SUCCESS = 'SAVE_MORTGAGE_BANK_MAKER_APPLICATION_SUCCESS';
export const SAVE_MORTGAGE_BANK_MAKER_APPLICATION_ERROR = 'SAVE_MORTGAGE_BANK_MAKER_APPLICATION_ERROR';

export const FETCH_MORTGAGE_VALUATORS = 'FETCH_MORTGAGE_VALUATORS';
export const FETCH_MORTGAGE_VALUATORS_SUCCESS = 'FETCH_MORTGAGE_VALUATORS_SUCCESS';
export const FETCH_MORTGAGE_VALUATORS_ERROR = 'FETCH_MORTGAGE_VALUATORS_ERROR';
export const CLEAR_MORTGAGE_VALUATORS = 'CLEAR_MORTGAGE_VALUATORS';

export const MORTGAGE_CLEAR_DATA = 'MORTGAGE_CLEAR_DATA';
export const MORTGAGE_CLEAR_ERROR = 'MORTGAGE_CLEAR_ERROR';
